import React from "react";

export default function PageHeader({ overline, title, description, actions }) {
  return (
    <div className="mb-8 lg:mb-10 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {overline ? <div className="text-overline mb-2">{overline}</div> : null}
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-foreground">
          {title}
        </h1>
        {description ? (
          <p className="mt-2 max-w-2xl text-muted-foreground leading-relaxed">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
    </div>
  );
}
